import { Injectable, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { LocalSettingsService } from './local-settings.service';

@Injectable({
   providedIn: 'root'
})
export class SEOService {
   constructor(private title: Title, @Inject(DOCUMENT) private doc: any,private _localSettings: LocalSettingsService,) {
   }
   setPageTitle(title: string) {
      this.title.setTitle(title);
   }
   getPageTitle() {
      return this.title.getTitle();
   }
   createLinkForCanonicalURL() {
      let url     = this.doc.URL;
      let url2    = this.doc.URL;
      const temp  = this.doc.URL;
      url = url.replace("http://","https://");
      url2 = url2.replace("http://","https://");

      const str  = temp.split('/');
      const lang = str[3];
      this.doc.documentElement.lang = lang;
      this.buildNode('canonical',lang,url);
      this.buildNode('alternate',lang,url);

      if(lang == 'en'){
         url2 = url2.replace("/en","/fr");
         this.buildNode('alternate','fr',url2);
      }
      else{
         url2 = url2.replace("/fr","/en");
         this.buildNode('alternate','en',url2);
      }
   }

   buildNode(type,lang,url){
      url.replace(/^\/+|\/+$/g, '');
      const link: HTMLLinkElement = this.doc.createElement('link');
      link.setAttribute('rel', type);
      link.setAttribute('hreflang', lang);
      link.setAttribute('href', url);
      this.doc.head.appendChild(link);
   }
}
